import { TableColumn } from '@/classes'

const ForgotPasswordListColumns = [
  new TableColumn('To Email', 'email', true, 'asc', 'left'),
  new TableColumn('Username', 'username', true, 'asc', 'left'),
  new TableColumn('Request Time', 'requestAt', true, 'desc', 'left'),
  new TableColumn('Reset Time', 'resetAt', true, 'desc', 'left')
]

export { ForgotPasswordListColumns }